import { z } from 'zod';

/**
 * Product-/verkoopomschrijving volgens het Klinger-sjabloon (secties: afsluiter, koppel-/brugstuk,
 * actuator, magneetventiel, switchbox/sensor/positioner, filter/reduceer, fitwerk, actuator-sizing).
 * De parser/serializer van de tekst zit in de frontend (`utils/salesDescription.ts`); dit is het
 * contract voor het AI-voorstel dat het formulier invult.
 */
export const DescriptionLangSchema = z.enum(['nl', 'en']);
export type DescriptionLang = z.infer<typeof DescriptionLangSchema>;

const field = z.string().max(2000).nullable().optional();

export const SalesDescriptionSuggestionSchema = z.object({
  /** Afsluiter: merk, type, maat/aansluiting, materialen (body/ball/stem/seals/bolting); bij 3/4-weg: boring! */
  valve: field,
  /** Koppel-/brugstuk (hoogte in mm), asadapter, montageplaatje */
  coupling: field,
  actuator_type: field,
  /** Stuurdruk in bar (alleen het getal) */
  actuator_air_supply: field,
  /** In line / haaks op de leiding */
  actuator_mounting: field,
  /** Air Failure Close (AFC) / Air Failure Open (AFO) / Stay In Place (STIP) / Double Acting */
  actuator_action: field,
  /** Eindkappen (bv. "Green RAL 6002"); leeg als standaard */
  actuator_end_caps: field,
  /** Magneetventiel, NAMUR-verloopplaat, snelheidsregelventiel — altijd de maat van de luchtpoorten */
  solenoid: field,
  switchbox: field,
  filter_regulator: field,
  fittings: field,
  sizing: z
    .object({
      air_supply: field,
      max_dp: field,
      safety_factor: field,
      torque_ex: field,
      torque_incl: field,
      actuator_torque_pressure: field,
      actuator_torque: field,
      mast: field,
      closing_time: field,
      opening_time: field,
    })
    .nullable()
    .optional(),
  /** Korte toelichting van de AI (bv. welke aannames zijn gedaan) */
  notes: z.string().max(1000).nullable().optional(),
});
export type SalesDescriptionSuggestion = z.infer<typeof SalesDescriptionSuggestionSchema>;

export const SuggestSalesDescriptionBodySchema = z.object({
  product_id: z.number().int().positive(),
  lang: DescriptionLangSchema.default('en'),
});
export type SuggestSalesDescriptionBody = z.infer<typeof SuggestSalesDescriptionBodySchema>;
